import { render, staticRenderFns } from "./GameOptions.vue?vue&type=template&id=27733cc3&scoped=true"
import script from "./GameOptions.vue?vue&type=script&lang=js"
export * from "./GameOptions.vue?vue&type=script&lang=js"
import style0 from "./GameOptions.vue?vue&type=style&index=0&id=27733cc3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27733cc3",
  null
  
)

export default component.exports